import { BrowserCacheLocation, Configuration, LogLevel } from "@azure/msal-browser";
import { environment } from "../../../environments/environment";
import { AuthService } from "./auth.service";


const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

/**
 * This file contains authentication parameters. Contents of this file
 * are roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

export const b2cPolicies = {
  names: {
    signUpSignIn: environment.auth.b2c.signUpSignInPolicy
  },
  authorities: {
    signUpSignIn: {
      authority:
        environment.auth.b2c.authority +
        environment.auth.b2c.domain +
        environment.auth.b2c.signUpSignInPolicy,
    }
  },
  authorityDomain: environment.auth.b2c.authorityDomain
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 */
export const msalConfig: Configuration = 
  environment.auth.defaultAuth == AuthService.aadAuthType ?
    //AAD configuration
    {
      auth: {
        clientId: environment.auth.aad.clientId, 
        authority: environment.auth.aad.authority, 
        redirectUri: environment.auth.aad.redirectUri, 
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage, 
        storeAuthStateInCookie: isIE, 
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Error,
          piiLoggingEnabled: true
        }
      }
    }
  : 
  //B2C Configuration
  {
    auth: {
      clientId: environment.auth.b2c.clientId,
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      redirectUri: environment.auth.b2c.redirectUri,
      postLogoutRedirectUri: environment.auth.b2c.postLogoutRedirectUri,
      knownAuthorities: [b2cPolicies.authorityDomain]
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, 
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: true
      }
    }
  }
;


export const protectedResources: { endpoint: string; scopes: string[] } = {
  endpoint: environment.privateApi,
  scopes: environment.auth.defaultAuth == AuthService.b2cAuthType ? environment.auth.b2c.scopes : environment.auth.aad.scopes,
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: []
};
